import { useDebug } from '@/hooks'
import { Button, View } from '@/components'
import { modal } from '@codeleap/modals'

export const DebugModal = modal({ id: 'debug-modal' }).content(({ toggle }) => {
  const debug = useDebug()

  return <View style={['gap:2', 'column']}>

    <Button
      debugName={'Submit logs'}
      text={'Submit logs'}
      onPress={debug.submitLogs}
    />

    <Button
      debugName={'Test Sentry crash'}
      text={'Test Sentry crash'}
      onPress={debug.testSentryCrash}
    />

    <Button
      debugName={'Test undefined.fuuuuu()'}
      text={'Test undefined.fuuuuu()'}
      onPress={debug.testUndefinedFunctionCall}
    />

    <Button
      debugName={'Test try catch'}
      text={'Test try catch'}
      onPress={debug.testTryCatch}
    />

    <Button
      debugName={'Test throwing an error'}
      text={'Test throwing an error'}
      onPress={debug.testThrowError}
    />

    <Button
      debugName={'Test logger.warn'}
      text={'Test logger.warn'}
      onPress={debug.testLoggerWarn}
    />

    <Button
      debugName={'Test logger.error'}
      text={'Test logger.error'}
      onPress={debug.testLoggerError}
    />

    <Button
      debugName={'Test logging circular dependency'}
      text={'Test logging circular dependency'}
      onPress={debug.testLoggingCircularDeps}
    />

    {/* <LanguageSelector /> */}
  </View>
})
